import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Link, Breadcrumbs as MuiBreadcrumbs, Typography } from "@mui/material";
import React from "react";
import { Link as RouterLink, useMatches } from "react-router-dom";
import { useTranslation } from "react-i18next";

export interface RouteMatch {
  id: string;
  pathname: string;
  data: any;
  params: Record<string, string>;
  handle?: {
    crumb: (match: RouteMatch) => CrumbData;
  };
}

export interface CrumbData extends RouteMatch {
  label: string;
  labelKey?: string;
  labelFallback?: string;
}

const Breadcrumbs: React.FC = () => {
  const { t } = useTranslation();
  const matches = useMatches() as RouteMatch[];

  const crumbs = matches
    .filter((match) => Boolean(match.handle?.crumb))
    .map((match) => match.handle!.crumb(match));

  const displayLabel = (crumb: CrumbData) =>
    crumb.labelKey ? t(crumb.labelKey, crumb.labelFallback ?? crumb.label) : crumb.label;

  const crumbsLength = crumbs?.length;
  if (crumbsLength < 2) {
    return null;
  }

  return (
    <>
      <MuiBreadcrumbs sx={{ pb: 1 }} separator={<NavigateNextIcon fontSize="small" />} aria-label={t('globalComponents.breadcrumb.ariaLabel', 'breadcrumb')}>
        {crumbs.map((crumb, index) => {
          const isLast = index === crumbs.length - 1;
          return isLast ? (
            <Typography
              key={crumb.pathname}
              color="text.primary"
              variant={crumbsLength === 1 ? 'title' : 'h4'}
              sx={{ display: "flex", alignItems: "center" }}
            >
              {displayLabel(crumb)}
            </Typography>
          ) : (
            <Link
              component={RouterLink}
              to={crumb.pathname}
              key={crumb.pathname}
              color="inherit"
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Typography variant={crumbsLength === 1 ? "title" : "h4"}>{displayLabel(crumb)}</Typography>
            </Link>
          );
        })}
      </MuiBreadcrumbs>
    </>
  );
};

export default Breadcrumbs;